import React, { FC, useMemo } from 'react'
import { SingleSpaParcel } from './SingleSpaParcel'
import { mfeConfigs } from '../../utilities/mfe'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { inject } from 'mobx-react'
import { LocalStorage } from '../../utilities/LocalStorage'
import { API } from '@getgreenline/homi-shared'
import { CurrentUserStore } from '../../stores/CurrentUserStore'

interface ICustomerPaymentPageProps {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
}

export const CustomerPaymentPage: FC<ICustomerPaymentPageProps> = inject(
  'currentCompanyStore',
  'currentUserStore',
)(({ currentCompanyStore, currentUserStore }) => {
  const locations = useMemo(
    () =>
      currentCompanyStore?.locations?.map((location) => ({
        name: location.name,
        companyName: currentCompanyStore.company?.name,
        merchantId: `blc-${currentCompanyStore.company?.id}-${location.id}`,
        email: currentUserStore?.currentUser?.email,
      })),
    [currentCompanyStore],
  )

  return (
    <SingleSpaParcel
      authToken={LocalStorage.getAuthToken}
      locations={locations}
      platform={'pos'}
      config={mfeConfigs.LOAD_PAYMENT_PAGE}
      services={{
        terminalListService: {
          fetchTerminalOptions: async () => {
            return await fetchTerminalOptions(currentCompanyStore?.company?.id)
          },
        },
      }}
    />
  )
})

const fetchTerminalOptions = async (companyId?: number) => {
  if (!companyId) return []
  const devices = await API.getDevices(companyId)

  return (
    devices?.map((terminal) => ({
      terminalId: terminal.id,
      terminalName: terminal.deviceId,
      terminalLocationId: terminal.locationId,
    })) || []
  )
}
